const PAGE_COPY = {
  overview: {
    eyebrow: 'VOICE OPERATIONS / LIVE',
    title: 'Overview',
    description: 'Monitor today\'s live call flow and current agent availability from AICC.',
  },
  pds: {
    eyebrow: 'VOICE OPERATIONS / OUTBOUND',
    title: 'Outbound Tasks',
    description: 'Create outbound tasks, track their progress, and let agents focus on every conversation.',
  },
  records: {
    eyebrow: 'VOICE OPERATIONS / HANDOFF',
    title: 'Handoff Records',
    description: 'Search bot-to-agent handoff results and review the bot-side call context.',
  },
  settings: {
    eyebrow: 'VOICE OPERATIONS / MANAGEMENT',
    title: 'Voice Settings',
    description: 'Review agent, skill and hotline settings, and check which features this account can use.',
  },
}

const TASK_STATE = {
  // 配色对齐 Bot 列表 Status：Active 青色 / Released 橙色 / Draft 灰色，进行中用主题蓝区分
  Running: { label: 'Running', tone: 'blue' },
  Paused: { label: 'Paused', tone: 'amber' },
  'Not Started': { label: 'Not Started', tone: 'neutral' },
  Finished: { label: 'Finished', tone: 'green' },
}

export function aiccPagePresentation(page) {
  return PAGE_COPY[page]
}

export function pdsTaskStatusPresentation(state) {
  return TASK_STATE[state] || { label: state || '—', tone: 'neutral' }
}

export function phoneWorkspacePresentation(mode, status = {}) {
  const collaboration = mode === 'collaboration'
  let stateLabel = 'Disconnected'
  let tone = 'neutral'
  if (status.activeCall) {
    stateLabel = 'On Call'
    tone = 'green'
  } else if (status.agentState === 'After_Call_Work') {
    stateLabel = 'After-Call Work'
    tone = 'amber'
  } else if (status.state === 'loading') {
    stateLabel = 'Connecting'
    tone = 'blue'
  } else if (status.state === 'connected') {
    stateLabel = status.agentState || 'Connected'
    tone = 'green'
  }

  return {
    eyebrow: collaboration ? 'VOICE OPERATIONS / HANDOFF' : 'VOICE OPERATIONS / OUTBOUND',
    title: collaboration ? 'AI Handoff Desk' : 'PD Agent Desk',
    description: collaboration
      ? 'Receive calls handed off by outbound bots.'
      : 'Receive auto-dialed outbound calls and record call outcomes.',
    modeLabel: collaboration ? 'Handoff' : 'Outbound',
    stateLabel,
    tone,
  }
}
